"use client";

import type { ReactNode } from "react";

export function PaletteFooter() {
  return (
    <div className="flex shrink-0 items-center justify-between border-t border-border bg-muted/40 px-4 py-2 text-caption text-muted-foreground">
      <div className="flex items-center gap-3">
        <Hint k="↑↓">navigate</Hint>
        <Hint k="↵">select</Hint>
        <Hint k="esc">back</Hint>
      </div>
      <div className="opacity-60 font-medium tracking-wider">HammerHead</div>
    </div>
  );
}

function Hint({ k, children }: { k: string; children: ReactNode }) {
  return (
    <span className="flex items-center gap-1">
      <kbd className="rounded-sm border border-border bg-background px-1.5 py-0.5 font-mono leading-none text-foreground">{k}</kbd>
      <span>{children}</span>
    </span>
  );
}
